export class SelectorEnum {
    static ERROR = "error";
}

export default SelectorEnum;
